export interface ReviewForSchema {
  customer_name: string;
  rating: number;
  comment: string;
  created_at: string;
}

export function buildReviewSchema(reviews: ReviewForSchema[]) {
  if (reviews.length === 0) return null;

  const totalRating = reviews.reduce((sum, r) => sum + r.rating, 0);
  const avgRating = (totalRating / reviews.length).toFixed(1);

  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'festutrustning.se',
    url: 'https://festutrustning.se',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: avgRating,
      bestRating: '5',
      worstRating: '1',
      reviewCount: String(reviews.length),
    },
    review: reviews.slice(0, 10).map((r) => ({
      '@type': 'Review',
      datePublished: r.created_at.split('T')[0],
      reviewRating: {
        '@type': 'Rating',
        ratingValue: String(r.rating),
        bestRating: '5',
        worstRating: '1',
      },
      author: {
        '@type': 'Person',
        name: r.customer_name,
      },
      reviewBody: r.comment,
    })),
  };
}
